import { Stack, SxProps, Theme as MTheme } from '@mui/material';
import { FC } from 'react';
import { FieldErrors } from 'react-hook-form';
import { Theme as theme } from '../../styles/theme/theme';

export const ConditionalFieldError: FC<IConditionalFieldError> = (props) => {
  const { errorMessage, errors, fieldName, sx } = props;
  const errorMessageForShow = errors[fieldName] ? errorMessage : '';

  return (
    <>
      {errorMessageForShow && (
        <Stack
          color={theme.palette.error.main}
          sx={{
            fontSize: '12px',
            fontFamily: theme.typography.fontFamily,
            ...sx,
          }}
        >
          {errorMessageForShow}
        </Stack>
      )}
    </>
  );
};

interface IConditionalFieldError {
  errorMessage: string;
  errors: FieldErrors<any>;
  fieldName: string;
  sx?: SxProps<MTheme>;
}
